import { render, staticRenderFns } from "./SiteSimpleImageArea.vue?vue&type=template&id=5ac664a7&scoped=true&"
import script from "./SiteSimpleImageArea.vue?vue&type=script&lang=ts&"
export * from "./SiteSimpleImageArea.vue?vue&type=script&lang=ts&"
import style0 from "./SiteSimpleImageArea.vue?vue&type=style&index=0&id=5ac664a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac664a7",
  null
  
)

export default component.exports